import { ReactElement } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

/** Classic mouse-pointer/cursor glyph (selection tool). */
export const CursorIcon = (props: SvgIconProps): ReactElement => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path d="m4 3 6.5 16 2.3-6.8L19.5 9.8z" />
    </SvgIcon>
  )
}
